var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLoupe = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7297 18.417L15.8933 14.5814C17.1417 13.0289 17.9028 11.0807 17.9028 8.94977C17.9028 4.01826 13.8838 0 8.95142 0C4.01901 0 0 4.01826 0 8.94977C0 13.8813 4.01901 17.8995 8.95142 17.8995C11.0827 17.8995 13.0618 17.1385 14.5841 15.8904L18.4204 19.726C18.6031 19.9087 18.8467 20 19.0598 20C19.273 20 19.5165 19.9087 19.6992 19.726C20.095 19.3303 20.095 18.7519 19.7297 18.417ZM1.85727 8.94977C1.85727 5.02283 5.0542 1.82648 8.98187 1.82648C12.9095 1.82648 16.1065 5.02283 16.1065 8.94977C16.1065 12.8767 12.8791 16.0426 8.98187 16.0426C5.08465 16.0426 1.85727 12.8463 1.85727 8.94977Z",
    fill: "#43927C"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLoupe, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/loupe.d8f64d68.svg";
export { ForwardRef as ReactComponent };